import { Outlet } from "react-router-dom";
import AppShell from "@/components/shell/app-shell";
import { MockDataBanner } from "@/components/ui/mock-data-banner";
import { ADMIN_PORTAL_NAV_SECTIONS } from "@/lib/constants";

export function AdminLayout() {
  return (
    <AppShell navSections={ADMIN_PORTAL_NAV_SECTIONS}>
      <MockDataBanner className="mb-5" />
      <Outlet />
    </AppShell>
  );
}
